/**
 * Guarda temporalmente en Redux los datos mínimos del abogado
 * elegido en el directorio ("Ubica tu abogado") para que chat.tsx pueda
 * leerlos al montarse y armar el chat "pendiente" (sin chat_id todavía),
 * sin depender de query params ni de location.state.

 */
const pending_lawyer = (state = null, action: any) => {
  switch (action.type) {
    case 'SET_PENDING_LAWYER':
      return action.payload;
    default:
      return state;
  }
};

export default pending_lawyer;
